// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5682":"css/admin-app.7062","8605":"css/app.7062"}[chunkId] + ".css";
};